import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from "react";
import { Accordion } from "@vfit/shared/atoms";
import { AccordionNavigationType } from "@vfit/shared/models";
import { useRouter } from "next/router";
import { AccordionNavigationContainer, AccordionLinksContent, AccordionNavigationLink, AccordionNavigationDefaultLink, AccordionNavigationInnerContainer, DefaultLinkWrapper } from "./accordionNavigation.style";
import { EVENTS_TYPE as FOOTER_EVENTS_TYPE, ONCLICK_EVENTS as FOOTER_ONCLICK_EVENTS } from "../Footer/footer.utils";
var AccordionNavigation = function(param) {
    var links = param.links, containerStyle = param.containerStyle, config = param.config, handlerClickMenu = param.handlerClickMenu, handlerTrackEvent = param.handlerTrackEvent, accordionNavigationType = param.accordionNavigationType;
    var router = useRouter();
    var ref = config || {}, backgroundColor = ref.backgroundColor, textColor = ref.textColor, padding = ref.padding, borderColor = ref.borderColor, fontFamily = ref.fontFamily, fontSize = ref.fontSize, fontWeight = ref.fontWeight, iconColor = ref.iconColor, iconSize = ref.iconSize, colorLinks = ref.colorLinks, fontFamilyLinks = ref.fontFamilyLinks, fontSizeLinks = ref.fontSizeLinks, fontWeightLinks = ref.fontWeightLinks, _enableHighlight = ref.enableHighlight, enableHighlight = _enableHighlight === void 0 ? false : _enableHighlight, highlightColor = ref.highlightColor, fontSizeSecondLevel = ref.fontSizeSecondLevel, fontFamilySecondLevel = ref.fontFamilySecondLevel, fontWeightSecondLevel = ref.fontWeightSecondLevel, lineHeight = ref.lineHeight, lineHeightLiks = ref.lineHeightLiks, lineHeightSecondLevel = ref.lineHeightSecondLevel, iconSizeSecondLevel = ref.iconSizeSecondLevel, marginLeftLink = ref.marginLeftLink, marginLeftSecondLevel = ref.marginLeftSecondLevel;
    var renderAccordion = function(title, content, enableBorder, isSecondLevel) {
        return /*#__PURE__*/ _jsx(Accordion, {
            accordionNavigationType: accordionNavigationType,
            background: backgroundColor,
            borderColor: enableBorder ? borderColor : "transparent",
            padding: padding,
            textColor: textColor,
            fontFamily: accordionNavigationType === AccordionNavigationType.MENU && isSecondLevel ? fontFamilySecondLevel : fontFamily,
            fontSize: accordionNavigationType === AccordionNavigationType.MENU && isSecondLevel ? fontSizeSecondLevel : fontSize,
            lineHeight: accordionNavigationType === AccordionNavigationType.MENU && isSecondLevel ? lineHeightSecondLevel : lineHeight,
            fontWeight: accordionNavigationType === AccordionNavigationType.MENU && isSecondLevel ? fontWeightSecondLevel : fontWeight,
            title: title,
            content: [
                content
            ],
            iconColor: iconColor,
            iconSize: accordionNavigationType === AccordionNavigationType.MENU && isSecondLevel ? iconSizeSecondLevel : iconSize,
            enableHighlight: enableHighlight,
            highlightColor: highlightColor
        });
    };
    var accordionLinks = function(items, fromFirstLevel) {
        return /*#__PURE__*/ _jsx(AccordionLinksContent, {
            children: Children.toArray(items.map(function(l) {
                if (!l.links || l.links.length === 0) {
                    if (fromFirstLevel) {
                        return /*#__PURE__*/ _jsx(AccordionNavigationLink, {
                            target: "_blank",
                            rel: "noreferrer",
                            href: l.url,
                            fontFamily: accordionNavigationType === AccordionNavigationType.MENU ? fontFamilyLinks : fontFamily,
                            fontSize: accordionNavigationType === AccordionNavigationType.MENU ? fontSizeLinks : fontSize,
                            fontWeight: accordionNavigationType === AccordionNavigationType.MENU ? fontWeightLinks : fontWeight,
                            background: backgroundColor,
                            color: textColor,
                            enableMargin: fromFirstLevel,
                            leftMargin: marginLeftLink,
                            lineHeight: accordionNavigationType === AccordionNavigationType.MENU ? lineHeightLiks : lineHeight,
                            children: l.category
                        });
                    }
                    return /*#__PURE__*/ _jsx(AccordionNavigationDefaultLink, {
                        onClick: function(evt) {
                            if (handlerClickMenu) {
                                handlerClickMenu(evt, l, // {
                                //   track: undefined,
                                //   name: tagName || `${onTrack}_MDD`,
                                // },
                                router);
                            } else if (handlerTrackEvent) {
                                handlerTrackEvent(l.category);
                            }
                            if (l.url && FOOTER_EVENTS_TYPE.includes(l.url)) {
                                evt.preventDefault();
                                FOOTER_ONCLICK_EVENTS[l.url]();
                            }
                        },
                        colorLinks: colorLinks,
                        fontFamilyLinks: fontFamilyLinks,
                        fontSizeLinks: fontSizeLinks,
                        fontWeightLinks: fontWeightLinks,
                        lineHeight: accordionNavigationType === AccordionNavigationType.MENU ? lineHeightLiks : lineHeight,
                        target: "_blank",
                        rel: "noreferrer",
                        href: l.url,
                        enableMargin: true,
                        leftMargin: marginLeftLink,
                        children: l.category
                    });
                }
                return /*#__PURE__*/ _jsx(AccordionNavigationContainer, {
                    enableMargin: true,
                    marginLeft: marginLeftSecondLevel,
                    style: _object_spread({}, containerStyle),
                    children: renderAccordion(l.category, accordionLinks(l.links || [], false), false, true)
                });
            }))
        });
    };
    return /*#__PURE__*/ _jsx(AccordionNavigationContainer, {
        style: _object_spread({}, containerStyle),
        children: Children.toArray(links === null || links === void 0 ? void 0 : links.map(function(l) {
            if (l.links) {
                return /*#__PURE__*/ _jsx(AccordionNavigationInnerContainer, {
                    accordionNavigationType: accordionNavigationType,
                    className: "accordionNavgationInnerContainer",
                    children: renderAccordion(l.category, accordionLinks(l.links || [], false))
                });
            }
            return /*#__PURE__*/ _jsx(DefaultLinkWrapper, {
                accordionNavigationType: accordionNavigationType,
                className: "defaultLinkWrapper",
                children: /*#__PURE__*/ _jsx(AccordionNavigationDefaultLink, {
                    onClick: function(evt) {
                        if (handlerClickMenu) handlerClickMenu(evt, l, router);
                    },
                    target: "_blank",
                    rel: "noreferrer",
                    href: l.url,
                    colorLinks: "#0d0d0d",
                    fontFamilyLinks: fontFamily,
                    fontSizeLinks: fontSize,
                    children: l.category
                })
            });
        }))
    });
};
export default AccordionNavigation;
